import { render, staticRenderFns } from "./control-text-color.vue?vue&type=template&id=3d996cd7&"
import script from "./control-text-color.vue?vue&type=script&lang=js&"
export * from "./control-text-color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports